module.exports = __webpack_public_path__ + "img/flag_cs.07584e37.png";